<template>
    <div class="account-agreement">
        <div class="open-wrapper pointer" @click="openModal">
            <slot>
                <a href="javascript://void(0)">Open</a>
            </slot>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               height="auto">
            <div class="dashboard-block" :class="{loading: loading}">
                <header>
                    <h4 v-if="model.created_at" class="display-block">
                        {{model.displayEnrolledVia}}
                        <span v-if="model.archivedLabel" v-html="model.archivedLabel"></span>
                    </h4>
                    <h4 v-else>Create Agreement</h4>

                    <h5 v-if="model.created_at">Agreement</h5>

                    <a href="javascript://void(0)" class="back" @click="closeModal">Close</a>
                </header>

                <div v-if="model.created_at">
                    <div class="row">
                        <div class="col-xs-6 col-sm-4">
                            <dl class="no-margin">
                                <dt>Charge</dt>
                                <dd>
                                    <h2 class="currency"
                                        v-html="$options.filters.displayCurrency(model.monthly_price)"></h2>
                                </dd>

                                <dt>Enrolled On</dt>
                                <dd>{{model.created_at | date}}</dd>
                            </dl>
                        </div>

                        <div class="col-xs-6 col-sm-8">
                            <dl class="no-margin">
                                <dt>Address</dt>
                                <dd>
                                    {{model.fullAddress}}
                                </dd>

                                <dt>Signed By</dt>
                                <dd v-if="model.signatories">
                                    {{model.signatories.join(', ')}}
                                </dd>
                            </dl>
                        </div>
                    </div>

                    <div>
                        <dl class="no-margin">
                            <dt>Files</dt>
                            <dd v-for="file in model.files" :key="file.id">
                                <a :href="'/files/' + file.id + '/download'" download class="display-block">
                                    {{file.name}}
                                </a>
                            </dd>
                        </dl>
                    </div>
                </div>

                <tabs>
                    <tab title="Email Notifications" v-if="model.created_at">
                        <fieldset>
                            <legend>Email Notifications</legend>

                            <div class="list-group">
                                <a href="javascript://void(0)" v-for="emailNotification in model.emailNotifications"
                                   :key="emailNotification.id">
                                    <h5 class="text-normal">
                                        {{emailNotification.subject}}
                                    </h5>

                                    <h6 class="text-med-grey text-normal margin-sm-bottom">
                                        <a :href="'mailto:' + emailNotification.to">{{emailNotification.to}}</a>

                                        <i class="fa fa-bell-o text-grey"
                                           v-if="!emailNotification.error_at && !emailNotification.sent_at"
                                           v-tooltip="'Email Queued'" aria-hidden="true"></i>

                                        <i class="fa fa-bell text-green"
                                           v-if="emailNotification.sent_at && !emailNotification.error_at"
                                           v-tooltip="'Email Sent'" aria-hidden="true"></i>

                                        <i class="fa fa-bell-slash text-red"
                                           v-if="emailNotification.error_at"
                                           v-tooltip="'Email Errored'" aria-hidden="true"></i>
                                    </h6>
                                </a>
                            </div>

                            <div class="row">
                                <div class="col-xs-6 col-lg-8">
                                </div>

                                <div class="col-xs-6 col-ld-4 form-group pull-right">
                                    <button @click="sendEmailNotifications" type="button"
                                            class="btn btn-primary btn-block"
                                            :disabled="loading">
                                        Send Notifications
                                    </button>
                                </div>
                            </div>
                        </fieldset>
                    </tab>

                    <tab :title="model.created_at ? 'Edit' : 'Create'">
                        <fieldset>
                            <legend>Update Enrollment</legend>

                            <form @submit.prevent="saveAgreement"
                                  accept-charset="UTF-8"
                                  enctype="multipart/form-data"
                                  method="POST"
                                  novalidate="novalidate"
                                  data-vv-scope="accountAgreement">
                                <div v-if="!model.created_at">
                                    <project-phone-agreement
                                        v-if="project.en_phone_agreement_id"
                                        class="text-right"
                                        :account-id="accountId"
                                        :accountable="accountable"
                                        :en-agreement-id="project.agreement_id"
                                        :es-agreement-id="project.es_phone_agreement_id"
                                        :model-id="'set-to-allow-load'"
                                        :project-id="project.id"
                                    >
                                        <a href="javascript://void">
                                            Show Phone Script
                                        </a>
                                    </project-phone-agreement>

                                    <div class="form-group has-feedback"
                                         :class="{'has-error': errors.has('accountAgreement.AccountAgreement[file]')}">
                                        <label for="account-agreement-file">
                                            Proof of Agreement
                                        </label>

                                        <input v-validate="'required'"
                                               aria-required="true"
                                               required="true"
                                               id="account-agreement-file"
                                               name="AccountAgreement[file]"
                                               type="file"
                                               class="form-control dropable"
                                               @change="onFileChange">

                                        <span v-show="errors.has('accountAgreement.AccountAgreement[file]')"
                                              class="help-block">
                                            {{ errors.first('accountAgreement.AccountAgreement[file]') }}
                                        </span>
                                    </div>

                                    <div class="form-group has-feedback"
                                         :class="{'has-error': errors.has('accountAgreement.AccountAgreement[address]')}">
                                        <label for="account-agreement-address">Resident Address</label>

                                        <input v-validate="'required'"
                                               v-model.string="model.address"
                                               class="form-control"
                                               aria-required="true"
                                               id="account-agreement-address"
                                               required
                                               name="AccountAgreement[address]">

                                        <span v-show="errors.has('accountAgreement.AccountAgreement[address]')"
                                              class="help-block">
                                        {{ errors.first('accountAgreement.AccountAgreement[address]') }}
                                    </span>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-4 form-group has-feedback"
                                             :class="{'has-error': errors.has('accountAgreement.AccountAgreement[city]')}">
                                            <label for="account-agreement-city">City</label>

                                            <input v-validate="'required'"
                                                   v-model.string="model.city"
                                                   class="form-control"
                                                   aria-required="true"
                                                   id="account-agreement-city"
                                                   required
                                                   name="AccountAgreement[city]">

                                            <span v-show="errors.has('accountAgreement.AccountAgreement[city]')"
                                                  class="help-block">
                                            {{ errors.first('accountAgreement.AccountAgreement[city]') }}
                                        </span>
                                        </div>

                                        <div class="col-sm-4 form-group has-feedback"
                                             :class="{'has-error': errors.has('accountAgreement.AccountAgreement[state]')}">
                                            <label for="account-agreement-state">State</label>

                                            <input v-validate="'required'"
                                                   v-model.string="model.state"
                                                   class="form-control"
                                                   aria-required="true"
                                                   id="account-agreement-state"
                                                   required
                                                   name="AccountAgreement[state]">

                                            <span v-show="errors.has('accountAgreement.AccountAgreement[state]')"
                                                  class="help-block">
                                            {{ errors.first('accountAgreement.AccountAgreement[state]') }}
                                        </span>
                                        </div>

                                        <div class="col-sm-4 form-group has-feedback"
                                             :class="{'has-error': errors.has('accountAgreement.AccountAgreement[postal_code]')}">
                                            <label for="account-agreement-postal-code">Postal Code</label>

                                            <input v-validate="'required'"
                                                   v-model.string="model.postal_code"
                                                   class="form-control"
                                                   aria-required="true"
                                                   id="account-agreement-postal-code"
                                                   required
                                                   name="AccountAgreement[postal_code]">

                                            <span v-show="errors.has('accountAgreement.AccountAgreement[postal_code]')"
                                                  class="help-block">
                                            {{ errors.first('accountAgreement.AccountAgreement[postal_code]') }}
                                        </span>
                                        </div>
                                    </div>

                                    <div class="signatories">
                                        <label>Signing Residents</label>

                                        <div class="form-group has-feedback"
                                             :class="{'has-error': errors.has('accountAgreement.AccountAgreement[signatories][' + index + ']')}"
                                             v-for="(signatory, index) in model.signatories" :key="index">

                                            <div class="input-group" v-if="index !== 0">
                                                <input v-validate="'required'"
                                                       v-model.string="signatory.name"
                                                       class="form-control"
                                                       aria-required="true"
                                                       required
                                                       :name="'accountAgreement.AccountAgreement[signatories][' + index + ']'">

                                                <span class="input-group-btn">
                                                    <button type="button" class="btn btn-warning btn-block"
                                                            @click="() => project.isMultiSignature ? null : removeSignatory(index)" :disabled="project.isMultiSignature">
                                                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                                                    </button>
                                                </span>
                                            </div>

                                            <input v-else
                                                   v-validate="'required'"
                                                   v-model.string="signatory.name"
                                                   class="form-control"
                                                   aria-required="true"
                                                   required
                                                   :name="'accountAgreement.AccountAgreement[signatories][' + index + ']'">
                                            <span
                                                v-show="errors.has('accountAgreement.AccountAgreement[signatories][' + index + ']')"
                                                class="help-block">
                                                {{ errors.first('accountAgreement.AccountAgreement[signatories][' + index + ']') }}
                                            </span>
                                        </div>

                                        <div class="form-group text-right">
                                            <a href="javascript://void(0)" @click="addSignatory">
                                                <i class="fa fa-user-plus" aria-hidden="true"></i> Add Signatory
                                            </a>
                                        </div>
                                    </div>

                                    <div class="form-group has-feedback"
                                         :class="{'has-error': errors.has('accountAgreement.AccountAgreement[send_notification]')}">

                                        <div class="checkbox">
                                            <label>
                                                <input v-model.boolean="model.send_notification"
                                                       type="checkbox"
                                                       id="account-agreement-send-notification"
                                                       name="AccountAgreement[send_notification]">

                                                Send Enrollment Notifications
                                            </label>
                                        </div>

                                        <span
                                            v-show="errors.has('accountAgreement.AccountAgreement[send_notification]')"
                                            class="help-block">
                                            {{ errors.first('accountAgreement.AccountAgreement[send_notification]') }}
                                        </span>
                                    </div>

                                    <hr>
                                </div>

                                <div class="row">
                                    <div class="col-xs-6 col-lg-8">
                                        <button type="button" class="btn btn-sm btn-warning"
                                                @click="() => project.isMultiSignature ? null : deleteModel()"
                                                v-if="model.created_at && !model.deleted_at"
                                                :disabled="project.isMultiSignature || loading">
                                            <i class="fa fa-trash" aria-hidden="true"></i>
                                        </button>

                                        <button type="button" class="btn btn-sm btn-warning"
                                                @click="restoreModel"
                                                v-if="model.created_at && model.deleted_at"
                                                :disabled="loading">
                                            <i class="fa fa-refresh" aria-hidden="true"></i>
                                        </button>
                                    </div>

                                    <div class="col-xs-6 col-ld-4 form-group pull-right" v-if="!model.created_at">
                                        <button type="submit" class="btn btn-success btn-block" :disabled="loading">
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </fieldset>
                    </tab>
                </tabs>
            </div>
        </modal>
    </div>
</template>

<script>
    import model from "./mixins/model";
    import ProjectPhoneAgreement from "./ProjectPhoneAgreement";

    export default {
        components: { ProjectPhoneAgreement },

        mixins: [ model ],

        props: {
            accountId: {
                required: true,
                type: String
            },

            accountable: {
                required: true,
                type: Object
            },

            project: {
                required: true,
                type: Object
            },
        },

        computed: {
            saveValidationKey(){
                return 'accountAgreement'
            },

            resourceKey(){
                return 'AccountAgreement';
            },

            url(){
                return '/api/accountAgreements/' + this.model.id;
            },
        },

        methods: {
            afterLoad( loadResults ){
                if( !this.model.id ){
                    this.setFields();
                }

                return Promise.resolve();
            },

            saveAgreement(){
                if( this.model.created_at ){
                    return false;
                }

                return this.$validator.validateAll( this.saveValidationKey )
                    .then( ( valid ) => {
                        if( valid ){
                            var promise;
                            this.loading = true;

                            this.beforeSave();

                            var data = new FormData();
                            data.append( 'AccountAgreement[account_id]', this.accountId );
                            data.append( 'AccountAgreement[monthly_price]', this.model.monthly_price );
                            data.append( 'AccountAgreement[address]', this.model.address );
                            data.append( 'AccountAgreement[city]', this.model.city );
                            data.append( 'AccountAgreement[state]', this.model.state );
                            data.append( 'AccountAgreement[postal_code]', this.model.postal_code );
                            data.append( 'AccountAgreement[file]', this.model.file );
                            data.append( 'AccountAgreement[send_notification]', this.model.send_notification );

                            _.each( this.model.signatories, ( signatory ) => {
                                data.append( 'AccountAgreement[signatories][]', signatory.name );
                            } );

                            return axios.post( '/api/accountAgreements', data, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            } )
                                .then( ( result ) => {
                                    if( !this.model.id ){
                                        this.setModel( result );
                                    }

                                    return this.init();
                                } )
                                .then( () => {
                                    this.$emit( 'afterSave' );

                                    if( this.closeOnSave ){
                                        this.closeModal();
                                    }

                                    this.$notify( {
                                        type: 'success',
                                        placement: 'top-left',
                                        title: 'Save Successful',
                                    } );
                                } )
                                .finally( () => {
                                    this.loading = false;
                                } )
                                .catch( ( err ) => {
                                    return this.$root.handleErrors( err, this.saveValidationKey );
                                } );
                        }
                    } );
            },

            setFields(){
                // AccountableType === App\User
                if( this.accountable.email ){
                    if( this.accountable.address ){
                        this.model.address = _.get( this, 'accountable.address.address' );
                        this.model.city = _.get( this, 'accountable.address.city' );
                        this.model.state = _.get( this, 'accountable.address.state' );
                        this.model.postal_code = _.get( this, 'accountable.address.postal_code' );
                    }

                    this.model.signatories.push( {
                        name: this.accountable.first_name + ' ' + this.accountable.last_name
                    } );
                }
                // AccountableType === App\Lease
                else if( _.isArray( this.accountable.residents ) &&
                    !_.isEmpty( this.accountable.residents ) ){

                    let resident = _.head( this.accountable.residents );

                    this.model.address = resident.address;
                    this.model.city = resident.city;
                    this.model.state = resident.state;
                    this.model.postal_code = resident.postal_code;

                    if( resident.address_2 ){
                        this.model.address += ' ' + resident.address_2;
                    }

                    _.each( this.accountable.residents, ( resident ) => {
                        this.model.signatories.push( {
                            name: resident.first_name + ' ' + resident.last_name
                        } );
                    } );
                }

                if( !this.model.address ){
                    this.model.address = _.get( this, 'project.property.address.address' );
                    this.model.city = _.get( this, 'project.property.address.city' );
                    this.model.state = _.get( this, 'project.property.address.state' );
                    this.model.postal_code = _.get( this, 'project.property.address.postal_code' );

                    if( _.get( this, 'project.property.address.address_2' ) ){
                        this.model.address += ' ' + _.get( this, 'project.property.address.address_2' );
                    }
                }

                if( _.isEmpty( this.model.signatories ) ){
                    this.model.signatories.push( {
                        name: null,
                    } );
                }
            },

            addSignatory(){
                this.model.signatories.push( { name: '' } );
            },

            removeSignatory( signatoryIndex ){
                if( signatoryIndex !== 0 ){
                    this.model.signatories.splice( signatoryIndex, 1 );
                }
            },

            sendEmailNotifications(){
                this.loading = true;

                return axios.post( '/api/accountAgreements/' + this.model.id + '/emailNotifications' )
                    .then( ( result ) => {
                        return this.init();
                    } )
                    .then( () => {
                        this.$emit( 'afterSave' );

                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Messages Queued',
                        } );
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( ( err ) => {
                        return this.$root.handleErrors( err );
                    } );
            },

            getModelData(){
                return {
                    closeOnSave: false,
                    model: {
                        signatories: [],
                        send_notification: true
                    },
                };
            },

            onFileChange( e ){
                this.model.file = e.target.files[ 0 ];
            },
        }
    }
</script>
